import axios from 'axios';
import {
  LOGIN_URL,
  TOKEN_URL,
  RESET_PASSWORD_URL,
  requestResetUrl,
} from '@/config';
import store from '@/store';

const login = (email, password) =>
  axios.post(LOGIN_URL, {
    email,
    password,
  });

// @todo check if this is needed
const logout = () => Promise.resolve(true);

const getToken = () =>
  axios.get(TOKEN_URL, {
    headers: {
      refresh_token: store.state.auth.refreshToken,
    },
  });

const requestResetPassword = email => axios.patch(requestResetUrl(email));

const resetPassword = ({ email, password, resetCode }) =>
  axios.patch(RESET_PASSWORD_URL, {
    email,
    password,
    password_reset_code: resetCode,
  });

export { login, logout, getToken, requestResetPassword, resetPassword };



// WEBPACK FOOTER //
// ./src/services/auth.js